import React from 'react';

import {
    SessionManager,
} from '../../../utilities/session-management/session-manager';

import i18n from '../../../utilities/i18n';

export const LogoutButton = () => {
    const handleLogout = () => {
        if (!SessionManager.session) {
            return;
        }

        SessionManager.endSession();
    };

    return (
        <button type="button"
                className="logout-btn"
                onClick={handleLogout}
        >
            {i18n.t('felles:logout')}
        </button>
    );
};
